import React, { useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import CalendarWrapper from "./CalendarWrapper";
import CustomToolbar from "./CustomToolbar";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useTranslation } from "react-i18next";
import { Alert, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import Div from "@jumbo/shared/Div";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import Typography from "@mui/material/Typography";
import { useNavigate, useParams } from "react-router-dom";
import { useBookingContext } from "../context";
import { useAppMutation } from "../../../../services";
import parentServices from "../../../../services/parent-services";
import styled from "@emotion/styled";
import "moment/locale/fr";
import "moment/locale/en-gb";

const StyledCircle = styled("div")(({ theme, color }) => ({
    backgroundColor: color,
    width: "10px",
    height: "10px",
    borderRadius: "50%",
}));

const localizer = momentLocalizer(moment);

const dayFormat = (date, culture, localizer) => localizer.format(date, "DD/MM/YYYY", culture);
const dayRangeHeaderFormat = ({ start, end }, culture, localizer) =>
    localizer.format(start, "DD/MM/YYYY", culture) + "-" + localizer.format(end, "DD/MM/YYYY", culture);

const dateFormat = "DD";
const dayHeaderFormat = "DD/MM/YYYY";

/* Month column headers: lun. mar. ... (lowercase) */
const weekdayFormat = (date, culture, localizer) => {
    const v = localizer.format(date, "ddd", culture);
    return String(v).toLowerCase();
};

const EventComponent = ({ event, index }) => {
    const formattedStartTime = new Date(event.start).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });

    return (
        <Div sx={{ display: "flex", alignItems: "center", height: 20 }} key={"calendar-" + index}>

            {/* ✅ removed red dot */}
            {event.attended === "not-attended" && (
                <Div
                    sx={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        backgroundColor: "#D22B2B",
                        flexShrink: 0,
                        mr:0.85,
                        position: "relative",
                        top: "-1px",
                    }}
                />
            )}

            <Typography sx={{ fontSize: 10 }} variant="caption" gutterBottom component="div">
                {event.student.firstName}
            </Typography>
            <Typography sx={{ fontSize: 10, ml: 0.5 }} variant="caption" gutterBottom component="div">
                {event.student.lastName}
            </Typography>
            <Typography sx={{ fontSize: 10, ml: 0.5 }} variant="caption" gutterBottom component="div">
                {"(" + formattedStartTime + ")"}
            </Typography>


        </Div>
    );
};


const EventComponentOld = ({ event, index }) => {
    const formattedStartTime = new Date(event.start).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });

    return (
        <Div sx={{ display: "flex", alignItems: "center", height: 20 }} key={"calendar-" + index}>
            <Typography sx={{ fontSize: 10 }} variant="caption" gutterBottom component="div">
                {event.student.firstName}
            </Typography>
            <Typography sx={{ fontSize: 10, ml: 0.5 }} variant="caption" gutterBottom component="div">
                {event.student.lastName}
            </Typography>
            <Typography sx={{ fontSize: 10, ml: 0.5 }} variant="caption" gutterBottom component="div">
                {"(" + formattedStartTime + ")"}
            </Typography>
            {event.attended === "not-attended" && (
                <Div sx={{ ml: 1 }}>
                    <StyledCircle color="#D22B2B" />
                </Div>
            )}
        </Div>
    );
};

const AgendaEventComponent = ({ event }) => {
    return (
        <Div>
            <Typography variant="h6" gutterBottom component="div">
                {event.title}
            </Typography>
            <Typography variant="h6" gutterBottom component="div">
                {event.student.firstName} {event.student.lastName}
            </Typography>
        </Div>
    );
};

const CalendarBasic = () => {
    const { globalState, setGlobalState } = useBookingContext();
    const { availableDates, setAvailableDates } = useBookingContext();
    const [minDate, setMinDate] = useState();
    const [maxDate, setMaxDate] = useState();
    const { t,i18n  } = useTranslation();
    const navigate = useNavigate();
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState("");
    const [events, setEvents] = useState([]);
    const params = useParams();
    const [searchStartDate, setSearchStartDate] = useState(new Date());

    // ✅ NEW: keep current view (only to apply selectable coloring in month view)
    const [view, setView] = useState("month");



    React.useEffect(() => {
        const lang = i18n.language?.startsWith("en") ? "en" : "fr";
        moment.locale(lang);
    }, [i18n.language]);


    const {
        mutate: loadBookings,
        isSuccess: isLBSuccess,
        data: lbResult,
    } = useAppMutation(parentServices.loadBookings);

    const {
        mutate: loadAvailableDates,
        isSuccess: isLDSuccess,
        isError: isLDError,
        data: ldResult,
    } = useAppMutation(parentServices.loadAvailableDates);

    const {
        mutate: loadActiveSubscriptions,
        isSuccess: isLASSuccess,
        data: lasData
    } = useAppMutation(parentServices.loadActiveSubscriptions);

    React.useEffect(() => {
        if (!minDate) {
            const currentMax = new Date();
            const min = new Date();
            setMinDate(min);
            currentMax.setDate(currentMax.getDate() + 30);
            setMaxDate(currentMax);

            const maxDate = new Date();
            maxDate.setMonth(maxDate.getMonth() + 3);
            maxDate.setHours(0, 0, 0, 0);
            loadActiveSubscriptions({
                date: min
            });
            loadAvailableDates({ startDate: min, endDate: maxDate, type: "courses" });
        }
    }, [minDate]);

    React.useEffect(() => {

        console.log('isLASSuccess', isLASSuccess, lasData)
        if (isLASSuccess && lasData) {

            const {subscription, subscriptions} = lasData;

            console.log('Subscriptions.......', subscription, subscriptions)


            setGlobalState({ ...globalState, subscriptions, subscription  : {...subscription}, refreshList: false });


        }
    }, [isLASSuccess, lasData])

    React.useEffect(() => {
        if (isLDSuccess) setAvailableDates(ldResult?.availableDates);
        else if (isLDError) setAvailableDates([]);
    }, [isLDError, isLDSuccess]);

    React.useEffect(() => {
        if (globalState.refreshList) {
            loadBookings({ startDate: searchStartDate });
            setGlobalState({ ...globalState, refreshList: false });
        }
    }, [globalState]);

    React.useEffect(() => {
        if (searchStartDate) loadBookings({ startDate: searchStartDate });
    }, [searchStartDate]);

    React.useEffect(() => {
        if (isLBSuccess) {
            const ev = [];
            for (const e of lbResult) {
                ev.push({ ...e, start: new Date(e.startDate), end: new Date(e.endDate) });
            }
            setEvents(ev);
        }
    }, [isLBSuccess]);

    const isPastDate = (date) => {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        return date < currentDate;
    };

    const handleSelectSlot = (slotInfo) => {

        const { ok, reason } = isSubscriptionValidForDate(slotInfo.start);

        if (!ok) {
            setErrMsg(t("calendar.noSubs"));
            setSnackbarOpen(true);
            setTimeout(() => setErrMsg(""), 3000);
            return;
        }

        const selectedDate = slotInfo.start;

        const today = new Date();
        today.setHours(0,0,0,0);

        const selected = new Date(selectedDate);
        selected.setHours(0,0,0,0);

        if (selected <= today) {
            setErrMsg(t("errMsg.pastDateMsg"));
            setSnackbarOpen(true);
            setTimeout(() => setErrMsg(""), 3000);
            return;
        }



        const maxDate = new Date();
        maxDate.setMonth(maxDate.getMonth() + 3);
        maxDate.setHours(0, 0, 0, 0);

        if (selectedDate < today || selectedDate >= maxDate) {
            setErrMsg(t("errMsg.monthMsg"));
            setSnackbarOpen(true);
            setTimeout(() => setErrMsg(""), 3000);
            return;
        }

        if (isPastDate(selectedDate)) {
            setErrMsg(t("errMsg.pastDateMsg"));
            setSnackbarOpen(true);
            setTimeout(() => setErrMsg(""), 3000);
            return;
        }

        if (availableDates && availableDates.indexOf(moment(selectedDate).format("YYYY-MM-DD")) === -1) {
            setErrMsg(t("errMsg.availableDate"));
            setSnackbarOpen(true);
            setTimeout(() => setErrMsg(""), 3000);
            return;
        }

        setSelectedDate(selectedDate);

        const adjustedDate = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000);
        const booking = {
            sstartDate: adjustedDate,
            startDate: moment(adjustedDate).format("YYYY-MM-DD"),
        };

        setGlobalState({ ...globalState, booking, minDate, maxDate, addEditBooking: true });
        loadAvailableDates({ startDate: minDate, endDate: maxDate, type: "courses" });
    };

    const [snackbarOpen, setSnackbarOpen] = React.useState(false);

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setErrMsg("");
    };

    const handleEventClick = (event) => {
        const v = {
            childId: event.student?.studentId,
            teacherId: event.teacher?.teacherId,
            bookingId: event.bookingId,
            description: event.description,
            sstartDate: new Date(event.startDate),
            attended: event.attended,
            startDate: moment(event.start).format("YYYY-MM-DD"),
            startTime: moment(event.start).format("HH:mm"),
        };
        setGlobalState({ ...globalState, booking: v, minDate, maxDate, addEditBooking: true });
    };

    const handleNavigate = (newDate, view, action) => {
        if (newDate.getMonth() !== searchStartDate.getMonth() || newDate.getFullYear() !== searchStartDate.getFullYear()) {
            setSearchStartDate(newDate);
        }
    };

    const availableDateTimestamps = React.useMemo(() => {
        if (!ldResult?.availableDates) return [];

        return ldResult.availableDates.map(dateStr => {
            const dt = new Date(dateStr);
            dt.setHours(0, 0, 0, 0);
            return dt.getTime();
        });
    }, [ldResult]);


    // ✅ NEW: mark selectable full cells (Month view only)
    const dayPropGetter = (date) => {
        if (view !== "month") return {};

        const { ok, reason } = isSubscriptionValidForDate(date);

        if (!ok) return {};

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const d = new Date(date);
        d.setHours(0, 0, 0, 0);

        // Only days in current visible month
        const inCurrentMonth =
            d.getMonth() === searchStartDate.getMonth() &&
            d.getFullYear() === searchStartDate.getFullYear();



        // ❌ Past dates → white
        if (d < today) return {};

        // ❌ Today → white (keep only black border from CSS)
        if (d.getTime() === today.getTime()) return {};

        // ❌ Not in available API list
        if (availableDateTimestamps.includes(d.getTime())) {
            if (!inCurrentMonth) return {className: "hc-selectable-day-light"};

            return { className: "hc-selectable-day" };
        }


        // ✅ Future selectable dates → RED
        return {   };
    };


    const renderSubscriptionAlertOld = () => {
        console.log('globalState',globalState)
        if (globalState && globalState.subscription) {
            const { subscription } = globalState;

            if (subscription.noOfUsedBooking < subscription.noOfBooking) {
                return (
                    <Stack sx={{ width: "100%" }} spacing={2}>
                        <Alert severity="success" onClose={() => {}}>
                            Booking Utilize {subscription.noOfUsedBooking}/{subscription.noOfBooking}
                        </Alert>
                    </Stack>
                );
            } else if (subscription.noOfBooking === subscription.noOfUsedBooking) {
                return (
                    <Stack sx={{ width: "100%" }} spacing={2}>
                        <Alert severity="warning" onClose={() => {}}>
                            Booking Utilize {subscription.noOfUsedBooking}/{subscription.noOfBooking}
                        </Alert>
                    </Stack>
                );
            }
        }
        return null;
    };

    const renderSubscriptionAlert = () => {
        console.log('globalState',globalState)
        if (globalState && globalState.subscription) {
            const { subscription } = globalState;


        }
        return null;
    };


    const hasActiveSubscription = React.useMemo(() => {
        const sub = globalState?.subscription;

        // if API returns null/undefined/empty object when no subscription
        if (!sub) return false;

        // If sometimes you store {} (empty object), this protects you
        if (Object.keys(sub).length === 0) return false;

        return true;
    }, [globalState?.subscription]);


    const isSubscriptionValidForDate = React.useCallback((slotDate) => {
        console.log('isSubscriptionValidForDate', slotDate);

        const subs = globalState?.subscriptions ?? [];

        if (!Array.isArray(subs) || subs.length === 0) {
            return { ok: false, reason: "missing" };
        }

        const slot = new Date(slotDate);
        if (Number.isNaN(slot.getTime())) {
            return { ok: false, reason: "bad_date" };
        }

        // compare by day only
        slot.setHours(0, 0, 0, 0);

        const matchedSub = subs.find((sub) => {
            if (!sub?.startDate || !sub?.expiredDate) return false;

            const start = new Date(sub.startDate);
            const expiry = new Date(sub.expiredDate);

            if (Number.isNaN(start.getTime()) || Number.isNaN(expiry.getTime())) {
                return false;
            }

            // full day range
            start.setHours(0, 0, 0, 0);
            expiry.setHours(23, 59, 59, 999);

            return slot.getTime() >= start.getTime() &&
                slot.getTime() <= expiry.getTime();
        });

        return matchedSub
            ? { ok: true, reason: "ok", subscription: matchedSub }
            : { ok: false, reason: "expired" };
    }, [globalState?.subscriptions]);

    return (
        <React.Fragment>
            <Stack sx={{ mb: 2, mt: -2 }} spacing={2}>
                {errMsg && <Alert severity="error">{errMsg}</Alert>}
            </Stack>

            {renderSubscriptionAlert()}

            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                culture={"pt-FR"}
                open={snackbarOpen}
                autoHideDuration={2500}
                startAccessor="startDate"
                endAccessor="endDate"
                onClose={handleSnackbarClose}
                message={errMsg}
                action={
                    <IconButton color={"primary"} size={"small"}>
                        <WarningAmberOutlinedIcon />
                    </IconButton>
                }
            />

            <Card>
                <CardContent>
                    <CalendarWrapper>
                        <Calendar
                            formats={{
                                dayHeaderFormat,
                                dateFormat,
                                dayFormat,
                                dayRangeHeaderFormat,
                                weekdayFormat,
                            }}
                            messages={{
                                next: "Suivant",
                                previous: "Précédent",
                                today: "Aujourd’hui",
                                month: "Mois",
                                week: "Semaine",
                                day: "Jour",
                                agenda: "Agenda",
                                event: "Event",
                                date: "Date",
                                time: "Time",
                            }}
                            localizer={localizer}
                            events={events}
                            step={15}
                            defaultDate={new Date()}
                            onNavigate={handleNavigate}
                            style={{ height: 700, overflowX: "auto" }}
                            selectable={true}
                            onSelectSlot={handleSelectSlot}
                            startAccessor="start"
                            endAccessor="end"
                            onSelectEvent={(event) => handleEventClick(event)}
                            eventPropGetter={(event) => {
                                let color = "";

                                if (event.bookingId) {
                                    // default: booked vs completed
                                    color = event.teacherFeedback?.ratings?.length > 0
                                        ? "#1D6ADE"   // completed
                                        : "#59B2FF";  // booked

                                    // ✅ no-show / not-attended => make chip red
                                    if (event.attended === "not-attended") {
                                        color = "#59B2FF";
                                    }

                                    // cancelled has priority (also red)
                                    if (event.cancelled) {
                                        color = "#D22B2B";
                                    }
                                }

                                return {
                                    style: {
                                        backgroundColor: color,
                                        color: "#ffffff",
                                        borderLeft: `4px solid ${color}`, // ✅ left bar same color
                                    },
                                };
                            }}


                            // ✅ NEW
                            view={view}
                            onView={(v) => setView(v)}
                            dayPropGetter={dayPropGetter}
                            components={{
                                toolbar: CustomToolbar,
                                event: EventComponent,
                                agenda: { event: AgendaEventComponent },
                            }}
                        />
                    </CalendarWrapper>
                </CardContent>
            </Card>

            <Div>
                <Dialog open={openDialog}>
                    <DialogTitle>{t("parent.title.title")}</DialogTitle>
                    <DialogContent />
                </Dialog>
            </Div>
        </React.Fragment>
    );
};

export default CalendarBasic;
